import { injectIntl } from 'react-intl';

import SeverityFilter from './SeverityFilter';

export default injectIntl(SeverityFilter);
